import { Menu } from 'antd';
import styled from 'styled-components';

const { Item } = Menu;

export const ItemMenuCustom = styled(Item)`
  span {
    white-space: normal;
  }

  height: 40px !important;

  &.ant-menu-item-selected {
    border-left: 4px solid #17b635;
    background-color: #fff !important;
    color: #090e38;
    font-weight: bold;
  }

  &&.ant-menu-item-selected span {
    background-color: #fff;
    color: #090e38;
    font-weight: bold;
  }
`;
